import $           from 'jquery';
import pageScripts from './pages';

import 'what-input';

require( 'slick-carousel/slick/slick' );

require( './lib/cart-amount' );

$( document ).ready( function () {
	//Require all components here.
	require( './components/expansion-panel' );
	require( './components/counter' );
	require( './components/foundation' );
	require( './components/brands-block' );
	require( './components/navigation' );
	require( './components/search-bar' );
	require( './components/forms' );
	require( './components/load-more' );
	require( './components/factory-data' );
	require( './components/search-autocomplete' );
	require( './components/product-add-to-cart' );
	require( './components/smooth-scrolling' );
	require( './components/currency-switch' );
	require( './components/confirm-form' );
	require( './components/languages' );
	require( './components/tooltip' );
	require( './components/notifications' );
	require( './components/header-banners' );

	//gravity-forms
	require( './components/gravity-forms/ask-a-question' );

	//Search
	require( './components/search/product-redirects' );
	require( './components/search/switch-view' );
	require( './components/search/switch-segment' );
	require( './components/search/brand-model' );
	require( './components/search/home-page' );

	//Product-detail
	require( './components/product-single/360viewer' );
	require( './components/product-single/product-header' );
	require( './components/product-single/product-alt-search' );
	require( './components/product-single/product-detail-list' );
	require( './components/product-single/product-detail-stock-notification' );
	require( './components/product-single/customer-number' );
	require( './components/product-single/customer-product-texts' );
	require( './components/product-single/question' );
	require( './components/product-single/product-detail-egos-data' );

	//Login
	require( './components/login/login-form' );
	require( './components/login/login-redirect' );
	require( './components/login/login-inactivity' );
	require( './components/login/login-error' );

	// Import all page-specific scripts
	document.body.className.replace( /-/g, '_' ).split( /\s+/ ).forEach( cls => {
		pageScripts[ cls ] && pageScripts[ cls ]();
	} );
} );

document.addEventListener( "DOMContentLoaded", ( event ) => {
	require( './components/components' );
} );